/**
 * モーダル系UIで起こりがちな２つの問題に対処する
 *  1. 裏側がスクロールされる現象
 *  2. 裏側にキーボードフォーカスされる現象
 *
 */

import { BODY } from "./_consts";
import { CSS_CAN_SCROLL } from "./_consts";

/**
 * scrollLock
 * 指定した要素以外のスクロールを抑止する
 * @param {Event} event イベント
 */
export function scrollLock(event) {
  const canScrollElement = event.target?.closest(CSS_CAN_SCROLL);

  if (canScrollElement === null) {
    // 対象の要素でなければスクロール禁止
    event.preventDefault();
    return;
  }

  if (canScrollElement && isScrollable(canScrollElement)) {
    // 対象の要素があり、その要素がスクロール可能であればスクロールを許可する
    event.stopPropagation();
  } else {
    // 対象の要素はスクロール禁止
    event.preventDefault();
  }
};

/**
 * scrollLockFix
 * スクロールのバグ対策を行うイベントを追加する
 * @param {DOM} element 対象のモーダル要素
 * @returns
 */
export function scrollLockFix(element) {
  // windowsとそれ以外でbody固定の方法を分ける
  // windowsはbody固定でスクロールバー分の横ずれが起きる
  if (isWindows()) {
    scrollLockFixWindows();
  } else {
    BODY.classList.add('is_scrollLock');
  }
  const canScrollElement = element.querySelector(CSS_CAN_SCROLL);

  if (!canScrollElement) {
    return;
  }

  canScrollElement.addEventListener('scroll', scrollLockTroubleShooting);
};

/**
 * scrollLockFixRemove
 * スクロールのバグ対策を行うイベントを削除する
 * @param {DOM} element 対象のモーダル要素
 * @returns
 */
export function scrollLockFixRemove(element) {
  if (isWindows()) {
    scrollLockFixRemoveWindows();
  } else {
    BODY.classList.remove('is_scrollLock');
  }
  const canScrollElement = element.querySelector(CSS_CAN_SCROLL);

  if (!canScrollElement) {
      return;
  }

  canScrollElement.removeEventListener('scroll', scrollLockTroubleShooting);
};

/**
 * isScrollable
 * スクロール可能か判定
 * @param {DOM} element スクロール可能要素
 * @returns {Boolean} スクロール可能かどうか
 */
function isScrollable(element) {
  return element.clientHeight < element.scrollHeight;
}

/**
 * scrollLockTroubleShooting
 * スクロールのバグ対策
 * @param {Event} event イベント
 */
function scrollLockTroubleShooting(event) {
  const element = event.target;

  if (element === null) {
    return;
  }

  // 以下の手順で発生するスクロールのバグ対策。回避するため1pxだけスクロール量を減らす
  // 1. メニューを上下どちらかに最大までスクロールする
  // 2. 更にスクロールを行うとページ全体がスクロールする
  if (element.scrollTop + element.clientHeight === element.scrollHeight) {
      element.scrollTop = element.scrollTop - 1;
  }

  if (element.scrollTop === 0) {
      element.scrollTop = 1;
  }
};

/**
 * Windows判定
 * @returns {Boolean} OSがWindowsであればtrue
 */
function isWindows() {
  return window.navigator.userAgent.toLowerCase().indexOf("windows nt") !== -1;
}

/** モーダルオープン時のスクロール位置を記録する */
let scrollPos = 0;

/**
 * windowsのときのbody固定処理
 */
function scrollLockFixWindows() {
  scrollPos = document.documentElement.scrollTop || BODY.scrollTop;
  BODY.classList.add('is_scrollLock-windows');
  BODY.style.top = `-${scrollPos}px`;
}

/**
 * windowsのときのbody固定処理の解除
 */
function scrollLockFixRemoveWindows() {
  BODY.classList.remove('is_scrollLock-windows');
  BODY.style.top = 'initial';
  BODY.scrollTop = scrollPos;
  document.documentElement.scrollTop = scrollPos;
}